import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalculatorPageComponent } from './pages/calculator-page/calculator-page.component';
import {CalculatorRoutingModule} from "./calculator-routing.module";
import {SharedModule} from "../../shared/shared.module";
import { PriceSummaryModalComponent } from './components/price-summary-modal/price-summary-modal.component';
import { NewCalculatorComponent } from './components/new-calculator/new-calculator.component';


@NgModule({
  declarations: [CalculatorPageComponent, PriceSummaryModalComponent, NewCalculatorComponent],
  imports: [
    CommonModule,
    CalculatorRoutingModule,
    SharedModule
  ],
  entryComponents: [
    PriceSummaryModalComponent
  ]
})
export class CalculatorModule { }
